<div class="layout-content">
	<div *ngIf="importing">
		<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<form *ngIf="!importing" (ngSubmit)="submit()" [formGroup]="exportForm">
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME_LIST' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" formControlName="name"
							placeholder="{{ 'NAME' | translate }}" maxlength="40" [disabled]="true" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'INSERT_ATLEAST_5CHARS' | translate
					}}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Action1, 'borderRow')">
					<div class="flex align-items-center justify-content-center gap-2"
						[ngClass]="newShowErrors(this.f.Action1, 'label')">{{ 'SUB_ACTION' | translate }}
						<p-button *ngIf="!this.onExtendedMobile()"
							pTooltip="{{ 'READ_INFO_FOR' | translate }} {{ 'IMPORT_SUBACTION' | translate }}" tooltipPosition="bottom"
							(click)="infoDialogGenericEntry()" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
					</div>
					<div class="flex align-items-end justify-content-center"
						[ngClass]="newShowErrors(this.f.Action1, 'borderInput')">
						<p-dropdown [options]="mtmaActions" optionLabel="Traslation" [ngClass]="dynamicInputTextWidth()" (onChange)="changedBoolDropdownVoice()"
							appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
							panelStyleClass="text-center" formControlName="Action1" placeholder="{{ 'SUB_ACTION' | translate }}"
							optionValue="Id" dataKey="Id">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Action1)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<ng-container formArrayName="deviceTypes">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="manageRespStylewithError(this.f.deviceTypes, 'borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStylewithError(this.f.deviceTypes, 'label')">
							{{ 'CONFIGS_DEVICE' | translate }}
						</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="manageRespStylewithError(this.f.deviceTypes, 'borderInput')">
							<p-checkbox *ngFor="let type of deviceTypes; let i = index" [formControlName]="i" (onChange)="onCheckboxChange()"
								[binary]="true" label="{{ getFieldCheckbox(type) | translate }}" [class]="showErrorRequiredCheckBox(this.f.deviceTypes)"
								class="ml-4 mt-2" [class]="showErrorRequiredCheckBox(this.f.deviceTypes)">
							</p-checkbox>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.deviceTypes)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'LIST_IMPORT_DATA_REQUIRE' | translate }}</small>
				</ng-container>
			</div>
			<div class="col-12 pt-0" [ngClass]="customPaddingX()">
				<ng-container formArrayName="usersTypes">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="manageRespStylewithError(this.f.usersTypes, 'borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStylewithError(this.f.usersTypes, 'label')">
							{{ 'USERS' | translate }}
						</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="manageRespStylewithError(this.f.usersTypes, 'borderInput')">
							<p-checkbox *ngFor="let type of usersTypes, let i = index" [formControlName]="i" (onChange)="onCheckboxChange()"
								[binary]="true" label="{{ getFieldCheckbox(type) | translate }}" [class]="showErrorRequiredCheckBox(this.f.usersTypes)"
								class="ml-4 mt-2" [class]="showErrorRequiredCheckBox(this.f.usersTypes)">
							</p-checkbox>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.usersTypes)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'LIST_IMPORT_DATA_REQUIRE' | translate }}</small>
				</ng-container>
			</div>
			<div class="col-12 pt-0" [ngClass]="customPaddingX()">
				<ng-container formArrayName="relationsTypes">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="manageRespStylewithError(this.f.relationsTypes, 'borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStylewithError(this.f.relationsTypes, 'label')">
							{{ 'ASSOCIATIONS' | translate }}
						</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="manageRespStylewithError(this.f.relationsTypes, 'borderInput')">
							<p-checkbox *ngFor="let type of relationsTypes, let i = index" [formControlName]="i"
								[binary]="true" label="{{ getFieldCheckbox(type) | translate }}" [class]="showErrorRequiredCheckBox(this.f.relationsTypes)"
								class="ml-4 mt-2" [class]="showErrorRequiredCheckBox(this.f.relationsTypes)">
							</p-checkbox>
						</div>
					</div>
					<!-- <small *ngIf="showErrorRequiredMessage(this.f.relationsTypes)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'LIST_IMPORT_DATA_REQUIRE' | translate }}</small> -->
				</ng-container>
			</div>
		</div>

		<div class="grid mt-5 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'IMPORT_OVERWRITE' | translate }}"
				class="p-button-warning text-xl font-normal mx-2 mb-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
				class="p-button-secondary text-xl font-normal mx-2 mb-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>